//@ts-nocheck
import React, { useState, useEffect } from "react";
import {
  Box,
  Chip,
  Container,
  Divider,
  Grid,
  Input,
  Tab,
  Tabs,
  TextField,
  Stack,
} from "@mui/material";
import {
  OutlinedButton,
  PrimaryButton,
  SecondaryButton,
  StyledIconButton,
} from "../components/StyledComponents/Buttons/AuradineButtons.js";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {
  BodyLarge,
  H6HeadlineSmall,
  H8TitleMedium,
  DataLegend,
  LabelLarge,
} from "../components/StyledComponents/Typography/Typography.tsx";
import HistoryIcon from "@mui/icons-material/History";
import DataGrid from "../components/DataGrid/DataGrid.tsx";
import StyledSwitch from "../components/StyledComponents/Switch/Switch.js";
import NotificationsDialog from "./Components/NotificationsDialog/NotificationsDialog.js";
import { useHistory } from "react-router-dom";
import useAppContextProvider from "../AppContext/useAppContextProvider.js";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { StyledCheckbox } from "../components/StyledComponents/Inputs/Inputs.js";

import * as api from "../api/api.js";
import { usePostAlertNotifications } from "./queries/usePostAlertNotifications.ts";
import { AddNotificationConfigurationDialog } from "./Components/AddNotificationConfigurationDialog/AddNotificationConfigurationDialog.js";
import AuradineErrorState from "../components/StyledComponents/EmptyStates/AuradineErrorState.tsx";
import StyledLinearProgress from "../components/StyledComponents/Progress/Progress.js";
import { format, parseISO } from "date-fns";
import PageWrapper from "../components/PageWrapper/PageWrapper.js";
import { useTheme } from "../ThemeContext/ThemeContext.js";

const HashBoardsMalfunctionTable = (props) => {
  const {
    datagridProps,
    selectionModel,
    refetch,
    tableKey,
    alertNotificationData,
    viewOnlyMode,
  } = props;
  const { colors } = useTheme();
  const { setToastOpen, setToastMessage } =
    useAppContextProvider();
  const { mutate: addAlertNotification } =
    usePostAlertNotifications();
  const unsubscribeHandler = () => {
    const selectedEmails =
      selectionModel && selectionModel.length > 0
        ? selectionModel.map((id) => {
            return id.split("-")[0];
          })
        : [];
    const finalData = alertNotificationData
      .filter((item) => {
        return selectedEmails.includes(item.email);
      })
      .map((item) => {
        return {
          ...item,
          alertNotificationConfig: {
            notifications:
              item.alertNotificationConfig.notifications.map(
                (notification) => {
                  if (
                    notification.type?.toLowerCase() ===
                    "hashboard malfunction"
                  ) {
                    return {
                      ...notification,
                      notifyMe: false,
                      subscribe: false,
                    };
                  }
                  return notification;
                }
              ),
          },
        };
      });
    addAlertNotification(
      { ...finalData },
      {
        onSuccess: async (data) => {
          if (data.status === "ok") {
            setToastOpen(true);
            setToastMessage(
              "Unsubscribed from notifications successfully"
            );
            await refetch();
            props.setTableKey((prev) => prev + 1);
          } else {
            setToastOpen(true);
            setToastMessage(
              "Error unsubscribing from notifications"
            );
          }
        },
        onError: (error) => {
          setToastOpen(true);
          setToastMessage(
            "Error unsubscribing from notifications"
          );
        },
      }
    );
  };
  return (
    <Box
      display="flex"
      flexDirection={"column"}
      gap={4}
      marginTop={4}
    >
      <Stack
        sx={{ padding: "1rem" }}
        direction={"row"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <BodyLarge>
          When there is a hash board malfunction, the
          following users have notifications sent to them at
          the set interval.
        </BodyLarge>
        <SecondaryButton colors={colors}
          disabled={
            selectionModel && selectionModel.length === 0
          }
          onClick={unsubscribeHandler}
        >
          Unsubscribe
        </SecondaryButton>
      </Stack>
      <Box
        className={"Datagrid-container"}
        display={"flex"}
        flexShrink={1}
      >
        <DataGrid
          colors={colors}
          key={tableKey}
          config={datagridProps}
          height="calc(100vh - 23rem)"
        />
      </Box>
    </Box>
  );
};
const PSUMalfunctionTable = (props) => {
  const {
    datagridProps,
    selectionModel,
    setTableKey,
    tableKey,
    refetch,
    alertNotificationData,
    viewOnlyMode,
  } = props;
  const { colors } = useTheme();
  const { setToastOpen, setToastMessage } =
    useAppContextProvider();
  const { mutate: addAlertNotification } =
    usePostAlertNotifications();
  const unsubscribeHandler = () => {
    const selectedEmails =
      selectionModel && selectionModel.length > 0
        ? selectionModel.map((id) => {
            return id.split("-")[0];
          })
        : [];
    const finalData = alertNotificationData
      .filter((item) => {
        return selectedEmails.includes(item.email);
      })
      .map((item) => {
        return {
          ...item,
          alertNotificationConfig: {
            notifications:
              item.alertNotificationConfig.notifications.map(
                (notification) => {
                  if (
                    notification.type?.toLowerCase() === "psu malfunction"
                  ) {
                    return {
                      ...notification,
                      notifyMe: false,
                      subscribe: false,
                    };
                  }
                  return notification;
                }
              ),
          },
        };
      });
    addAlertNotification(
      { ...finalData },
      {
        onSuccess: async (data) => {
          if (data.status === "ok") {
            setToastOpen(true);
            setToastMessage(
              "Unsubscribed from notifications successfully"
            );
            await refetch();
            props.setTableKey((prev) => prev + 1);
          } else {
            setToastOpen(true);
            setToastMessage(
              "Error unsubscribing from notifications"
            );
          }
        },
        onError: (error) => {
          setToastOpen(true);
          setToastMessage(
            "Error unsubscribing from notifications"
          );
        },
      }
    );
  };
  return (
    <Box
      display="flex"
      flexDirection={"column"}
      gap={4}
      marginTop={4}
    >
      <Stack
        sx={{ padding: "1rem" }}
        direction={"row"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <BodyLarge>
          When there is a PSU malfunction, the following
          users have notifications sent to them at the set
          interval.
        </BodyLarge>
        <SecondaryButton colors={colors}
          onClick={() => unsubscribeHandler()}
          disabled={
            selectionModel && selectionModel.length === 0
          }
        >
          Unsubscribe
        </SecondaryButton>
      </Stack>
      <Box
        className={"Datagrid-container"}
        display={"flex"}
        flexShrink={1}
      >
        <DataGrid
          colors={colors}
          config={datagridProps}
          height="calc(100vh - 23rem)"
          key={tableKey}
        />
      </Box>
    </Box>
  );
};
const FanMalfunctionTable = (props) => {
  const {
    datagridProps,
    selectionModel,
    setTableKey,
    tableKey,
    refetch,
    alertNotificationData,
    viewOnlyMode,
  } = props;
  const { colors } = useTheme();
  const { setToastOpen, setToastMessage } =
    useAppContextProvider();
  const { mutate: addAlertNotification } =
    usePostAlertNotifications();
  const unsubscribeHandler = () => {
    const selectedEmails =
      selectionModel && selectionModel.length > 0
        ? selectionModel.map((id) => {
            return id.split("-")[0];
          })
        : [];
    const finalData = alertNotificationData
      .filter((item) => {
        return selectedEmails.includes(item.email);
      })
      .map((item) => {
        return {
          ...item,
          alertNotificationConfig: {
            notifications:
              item.alertNotificationConfig.notifications.map(
                (notification) => {
                  if (
                    notification.type?.toLowerCase() === "fan malfunction"
                  ) {
                    return {
                      ...notification,
                      notifyMe: false,
                      subscribe: false,
                    };
                  }
                  return notification;
                }
              ),
          },
        };
      });
    addAlertNotification(
      { ...finalData },
      {
        onSuccess: async (data) => {
          if (data.status === "ok") {
            setToastOpen(true);
            setToastMessage(
              "Unsubscribed from notifications successfully"
            );
            await refetch();
            props.setTableKey((prev) => prev + 1);
          } else {
            setToastOpen(true);
            setToastMessage(
              "Error unsubscribing from notifications"
            );
          }
        },
        onError: (error) => {
          setToastOpen(true);
          setToastMessage(
            "Error unsubscribing from notifications"
          );
        },
      }
    );
  };
  return (
    <Box
      display="flex"
      flexDirection={"column"}
      gap={4}
      marginTop={4}
    >
      <Stack
        sx={{ padding: "1rem" }}
        direction={"row"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <BodyLarge>
          When there is a fan malfunction, the following
          users have notifications sent to them at the set
          interval.
        </BodyLarge>
        <SecondaryButton colors={colors}
          disabled={
            selectionModel && selectionModel.length === 0
          }
          onClick={unsubscribeHandler}
        >
          Unsubscribe
        </SecondaryButton>
      </Stack>
      <Box
        className={"Datagrid-container"}
        display={"flex"}
        flexShrink={1}
      >
        <DataGrid
          colors={colors}
          config={datagridProps}
          height="calc(100vh - 23rem)"
          key={tableKey}
        />
      </Box>
    </Box>
  );
};

const LeakDetectionTable = (props) => {
  const {
    datagridProps,
    selectionModel,
    setTableKey,
    tableKey,
    refetch,
    alertNotificationData,
    viewOnlyMode,
  } = props;
  const { colors } = useTheme();
  const { setToastOpen, setToastMessage } =
    useAppContextProvider();
  const { mutate: addAlertNotification } =
    usePostAlertNotifications();
  const unsubscribeHandler = () => {
    const selectedEmails =
      selectionModel && selectionModel.length > 0
        ? selectionModel.map((id) => {
            return id.split("-")[0];
          })
        : [];
    const finalData = alertNotificationData
      .filter((item) => {
        return selectedEmails.includes(item.email);
      })
      .map((item) => {
        return {
          ...item,
          alertNotificationConfig: {
            notifications:
              item.alertNotificationConfig.notifications.map(
                (notification) => {
                  if (
                    notification.type?.toLowerCase() === "leak detection"
                  ) {
                    return {
                      ...notification,
                      notifyMe: false,
                      subscribe: false,
                    };
                  }
                  return notification;
                }
              ),
          },
        };
      });
    addAlertNotification(
      { ...finalData },
      {
        onSuccess: async (data) => {
          if (data.status === "ok") {
            setToastOpen(true);
            setToastMessage(
              "Unsubscribed from notifications successfully"
            );
            await refetch();
            props.setTableKey((prev) => prev + 1);
          } else {
            setToastOpen(true);
            setToastMessage(
              "Error unsubscribing from notifications"
            );
          }
        },
        onError: (error) => {
          setToastOpen(true);
          setToastMessage(
            "Error unsubscribing from notifications"
          );
        },
      }
    );
  };
  return (
    <Box
      display="flex"
      flexDirection={"column"}
      gap={4}
      marginTop={4}
    >
      <Stack
        sx={{ padding: "1rem" }}
        direction={"row"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <BodyLarge>
          When a leak is detected, the following
          users have notifications sent to them at the set
          interval.
        </BodyLarge>
        <SecondaryButton colors={colors}
          disabled={
            selectionModel && selectionModel.length === 0
          }
          onClick={unsubscribeHandler}
        >
          Unsubscribe
        </SecondaryButton>
      </Stack>
      <Box
        className={"Datagrid-container"}
        display={"flex"}
        flexShrink={1}
      >
        <DataGrid
          colors={colors}
          config={datagridProps}
          height="calc(100vh - 23rem)"
          key={tableKey}
        />
      </Box>
    </Box>
  );
};

const ChipMalfunctionTable = (props) => {
  const {
    datagridProps,
    selectionModel,
    setTableKey,
    tableKey,
    refetch,
    alertNotificationData,
    viewOnlyMode,
  } = props;
  const { colors } = useTheme();
  const { setToastOpen, setToastMessage } =
    useAppContextProvider();
  const { mutate: addAlertNotification } =
    usePostAlertNotifications();
  const unsubscribeHandler = () => {
    const selectedEmails =
      selectionModel && selectionModel.length > 0
        ? selectionModel.map((id) => {
            return id.split("-")[0];
          })
        : [];
    const finalData = alertNotificationData
      .filter((item) => {
        return selectedEmails.includes(item.email);
      })
      .map((item) => {
        return {
          ...item,
          alertNotificationConfig: {
            notifications:
              item.alertNotificationConfig.notifications.map(
                (notification) => {
                  if (
                    notification.type?.toLowerCase() === "chip temperature"
                  ) {
                    return {
                      ...notification,
                      notifyMe: false,
                      subscribe: false,
                    };
                  }
                  return notification;
                }
              ),
          },
        };
      });
    addAlertNotification(
      { ...finalData },
      {
        onSuccess: async (data) => {
          if (data.status === "ok") {
            setToastOpen(true);
            setToastMessage(
              "Unsubscribed from notifications successfully"
            );
            await refetch();
            props.setTableKey((prev) => prev + 1);
          } else {
            setToastOpen(true);
            setToastMessage(
              "Error unsubscribing from notifications"
            );
          }
        },
        onError: (error) => {
          setToastOpen(true);
          setToastMessage(
            "Error unsubscribing from notifications"
          );
        },
      }
    );
  };
  return (
    <Box
      display="flex"
      flexDirection={"column"}
      gap={4}
      marginTop={4}
    >
      <Stack
        sx={{ padding: "1rem" }}
        direction={"row"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <BodyLarge>
          When there is a chip malfunction, the following
          users have notifications sent to them at the set
          interval.
        </BodyLarge>
        <SecondaryButton colors={colors}
          disabled={
            selectionModel && selectionModel.length === 0
          }
          onClick={unsubscribeHandler}
        >
          Unsubscribe
        </SecondaryButton>
      </Stack>
      <Box
        className={"Datagrid-container"}
        display={"flex"}
        flexShrink={1}
      >
        <DataGrid
          colors={colors}
          config={datagridProps}
          height="calc(100vh - 23rem)"
          key={tableKey}
        />
      </Box>
    </Box>
  );
};

const NotificationsPageHeader = (props) => {
  const {
    refetch,
    setOpenNotificationConfigurationDialog,
    viewOnlyMode,
  } = props;
  const [open, setOpen] = React.useState(false);
  const navigate = useHistory();
  const { colors } = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="row"
      gap={2.48}
      marginBottom={"1.5rem"}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent={"space-between"}
        flexGrow={1}
      >
        <Box
          display="flex"
          flexDirection="column"
          gap={4}
          justifyContent="flex-start"
        >
          <H6HeadlineSmall>Notifications</H6HeadlineSmall>
          <BodyLarge>
            View and edit notifications for each user.
          </BodyLarge>
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          minWidth={"2.98rem"}
          gap={2}
          justifyContent="flex-end"
          alignItems={"center"}
        >
          <SecondaryButton colors={colors}
            disabled={viewOnlyMode}
            endIcon={
              <span className="material-symbols-outlined">
                add_alert
              </span>
            }
            onClick={() =>
              setOpenNotificationConfigurationDialog(true)
            }
          >
            Configure alerts
          </SecondaryButton>
          <PrimaryButton colors={colors}
            disabled={viewOnlyMode}
            endIcon={
              <AddIcon
                fontSize="small"
                sx={{ color: "white" }}
              />
            }
            onClick={() => setOpen(true)}
          >
            Add{" "}
          </PrimaryButton>
        </Box>
      </Box>
      <NotificationsDialog
        open={open}
        handleClose={() => setOpen(false)}
        refetch={refetch}
      />
    </Box>
  );
};

const NotificationsPage = () => {
  const { colors } = useTheme();
  const [selectedTab, setSelectedTab] = React.useState(0);
  const navigate = useHistory();

  const [org, setOrg] = useState({});
  const [authToken, setAuthToken] = useState("");
  const [
    hashboardSelectionModel,
    setHashboardSelectionModel,
  ] = useState([]);
  const [fanSelectionModel, setFanSelectionModel] =
    useState([]);
  const [leakSelectionModel, setLeakSelectionModel] =
    useState([]);
  const [psuSelectionModel, setPsuSelectionModel] =
    useState([]);
  const [chipSelectionModel, setChipSelectionModel] =
    useState([]);
  const [hashboardTableKey, setHashboardTableKey] =
    useState(0);
  const [fanTableKey, setFanTableKey] = useState(0);
  const [leakTableKey, setLeakTableKey] = useState(0);
  const [psuTableKey, setPsuTableKey] = useState(0);
  const [chipTableKey, setChipTableKey] = useState(0);
  const [
    openNotificationConfigurationDialog,
    setOpenNotificationConfigurationDialog,
  ] = useState(false);

  const { isAuthenticated, getAccessTokenSilently } =
    useAuth0(); // Use the useAuth0 hook to get authentication status and token fetching function

  const { mutate: addAlertNotification } =
    usePostAlertNotifications();

  const { setToastOpen, setToastMessage } =
    useAppContextProvider();

  useEffect(() => {
    const fetchToken = async () => {
      try {
        if (!isAuthenticated) {
          setAuthToken("");
          console.warn(
            "User is not authenticated. Fetching token..."
          );
          return;
        }
        const token = await getAccessTokenSilently({
          cacheMode: "cache-only",
          ignoreCache: true,
        });
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
    const interval = setInterval(() => {
      fetchToken();
    }, 5 * 60 * 1000); // Refresh every 15 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, [getAccessTokenSilently, isAuthenticated]);

  const {
    data: alertNotificationsData,
    isLoading: isAlertsDataLoading,
    isFetched: alertDataFetched,
    isRefetched,
    isRefetching: isAlertsDataRefetching,
    isError,
    refetch: refetchAlertNotifications,
  } = useQuery({
    queryKey: ["notifications"],
    queryFn: () => api.GetAlertSubscriptions(authToken),
    enabled: !!authToken,
  });
  let alertNotificationData = [];
  if (alertDataFetched && alertNotificationsData) {
    alertNotificationData =
      alertNotificationsData.status === "ok" &&
      alertNotificationsData.subscriptions.length > 0
        ? alertNotificationsData.subscriptions
        : [];
  }
  function convertNotifications(input) {
    if (!input || input.length === 0) {
      return {};
    }
    return input
      .flatMap((alertSubscription) => {
        const useremail = alertSubscription.email;
        if (!alertSubscription.alertNotificationConfig) {
          return [];
        }
        const notification =
          alertSubscription.alertNotificationConfig
            .notifications;

        return Array.isArray(notification) &&
          notification.length > 0
          ? notification.map((notification, index) => {
              return {
                id: `${useremail}-${notification.type}`, // unique ID
                alertType: notification.type,
                user: useremail.split("@")[0],
                email: useremail,
                createdAt: notification.createdAt,
                lastModified: notification.updatedAt,
                notifyMe: notification.notifyMe,
                subscribe: notification.subscribe,
              };
            })
          : [];
      })
      .filter((record) => record.subscribe === true);
  }
  const {
    data: userData,
    isLoading: isuserDataLoading,
    isFetching,
    isError: isUserDataError,
    isFetched,
    refetch,
  } = useQuery({
    queryKey: ["user"],
    queryFn: ({ queryKey }) =>
      api.GetUserUseQuery(authToken),
    enabled: !!authToken,
  });
  const role = isFetched && userData?.user.role;
  let viewOnlyMode = false;
  if (role && role !== "superadmin") {
    viewOnlyMode = true;
  }
  const notifications = convertNotifications(
    alertNotificationData
  );
  const fanMalFunctionData =
    notifications.length > 0
      ? notifications.filter(
          (item) => item.alertType?.toLowerCase() === "fan malfunction"
        )
      : [];
    const leakDetectionData =
    notifications.length > 0
      ? notifications.filter(
          (item) => item.alertType?.toLowerCase() === "leak detection"
        )
      : [];
  const hashBoardMalFunctionData =
    notifications.length > 0
      ? notifications.filter(
          (item) =>
            item.alertType?.toLowerCase() === "hashboard malfunction"
        )
      : [];
  const psuMalFunctionData =
    notifications.length > 0
      ? notifications.filter(
          (item) => item.alertType?.toLowerCase() === "psu malfunction"
        )
      : [];
  const chipMalFunctionData =
    notifications.length > 0
      ? notifications.filter(
          (item) => item.alertType?.toLowerCase() === "chip temperature"
        )
      : [];
  const CustomGridRowsOverlay = () => {
    if (
      (fanMalFunctionData.length === 0 ||
        leakDetectionData.length === 0 ||
        hashBoardMalFunctionData.length === 0 ||
        psuMalFunctionData.length === 0 ||
        chipMalFunctionData.length === 0) &&
      alertDataFetched &&
      alertNotificationsData.status === "ok"
    ) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          sx={{
            backgroundColor: colors?.background?.paper, // Custom background color
            color: colors?.text?.muted, // Custom text color
            fontSize: "1.2rem",
            fontWeight: "bold",
          }}
        >
          No data available
        </Box>
      );
    }
    if (
      isError ||
      (alertDataFetched &&
        alertNotificationsData.status.toLowerCase() ===
          "error")
    ) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          sx={{
            backgroundColor: colors?.background?.paper, // Custom background color
            color: colors?.text?.muted, // Custom text color
            fontSize: "1.2rem",
            fontWeight: "bold",
          }}
        >
          <AuradineErrorState message="Oops!! Something went wrong!!" />
        </Box>
      );
    }
  };

  const handleSwitchChange = (event, id) => {
    if (!id) return;
    else {
      const [email, issue] = id.split("-");
      const finalData = alertNotificationData
        .filter((item) => {
          return item.email === email;
        })
        .map((item) => {
          return {
            ...item,
            alertNotificationConfig: {
              notifications:
                item.alertNotificationConfig.notifications.map(
                  (notification) => {
                    if (notification.type?.toLowerCase() === issue?.toLowerCase()) {
                      return {
                        ...notification,
                        notifyMe: event.target.checked,
                      };
                    }
                    return notification;
                  }
                ),
            },
          };
        });
      addAlertNotification(
        { ...finalData },
        {
          onSuccess: async (data) => {
            if (data.status === "ok") {
              setToastOpen(true);
              setToastMessage(
                `Notifications for ${issue} have been ${
                  event.target.checked
                    ? `turned off`
                    : `turned on`
                } for ${email} successfully`
              );
              if (issue?.toLowerCase() === "chip temperature") {
                setChipTableKey((prev) => prev + 1);
              } else if (issue?.toLowerCase() === "fan malfunction") {
                setFanTableKey((prev) => prev + 1);
              } else if (issue?.toLowerCase() === "psu malfunction") {
                setPsuTableKey((prev) => prev + 1);
              } else if (issue?.toLowerCase() === "leak detection") {
                setPsuTableKey((prev) => prev + 1);
              } else if (
                issue?.toLowerCase() === "hashboard malfunction"
              ) {
                setHashboardTableKey((prev) => prev + 1);
              }
              await refetchAlertNotifications();
            } else {
              setToastOpen(true);
              setToastMessage(
                `Error modifying notifications for user ${email}`
              );
            }
          },
          onError: (error) => {
            setToastOpen(true);
            setToastMessage(
              `Error modifying notifications for user ${email}`
            );
          },
        }
      );
    }
  };

  let columns = [
    {
      field: "user",
      headerName: "User",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "createdAt",
      headerName: "Created at",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => {
        return params
          ? format(parseISO(params), "MM/dd/yyyy HH:mm:ss ")
          : null;
      },
    },
    {
      field: "lastModified",
      headerName: "Last modified",
      minWidth: 150,
      flex: 1,
      valueGetter: (params) => {
        return params
          ? format(parseISO(params), "MM/dd/yyyy HH:mm:ss ")
          : null;
      },
    },

    {
      field: "notifyMe",
      headerName: "Active",
      flex: 1,
      renderCell: (params) => {
        return (
          <Box display={"flex"} flexDirection={"row"}>
            <StyledSwitch
              colors={colors}
              checked={params.value}
              disabled={viewOnlyMode}
              onClick={(event) => event.stopPropagation()}
              onChange={(event) =>
                handleSwitchChange(event, params.id)
              }
            />
          </Box>
        );
      },
    },
  ];

  const hashboardMalfuncDataGridProps = React.useMemo(
    () => ({
      rows: Array.isArray(hashBoardMalFunctionData)
        ? hashBoardMalFunctionData
        : [],
      columns: [...columns],
      page: 0,
      getRowId: (row) => row.id,
      pagination: true,
      pageSize: hashBoardMalFunctionData.length,
      disableColumnMenu: true,
      disableColumnResize: true,
      checkboxSelection: !viewOnlyMode,
      disableSelectionOnClick: true,
      disableCellSelection: true,
      loading:
        isAlertsDataLoading || isAlertsDataRefetching,
      selectionModel: hashboardSelectionModel,
      onRowSelectionModelChange: viewOnlyMode
        ? null // Disable row selection in view-only mode
        : (newSelection) => {
            setHashboardSelectionModel(newSelection);
          },
      slots: {
        baseCheckbox: StyledCheckbox,
        noRowsOverlay: CustomGridRowsOverlay,
        loadingOverlay: () => <StyledLinearProgress colors={colors} />,
      },
    }),
    [
      hashBoardMalFunctionData,
      hashboardSelectionModel,
      columns,
    ]
  );

  const psuMalfunctionDataGridProps = React.useMemo(
    () => ({
      rows: Array.isArray(psuMalFunctionData)
        ? psuMalFunctionData
        : [],
      columns: [...columns],
      page: 0,
      loading:
        isAlertsDataLoading || isAlertsDataRefetching,
      getRowId: (row) => row.id,
      pagination: true,
      pageSize: psuMalFunctionData.length,
      disableColumnMenu: true,
      disableColumnResize: true,
      checkboxSelection: !viewOnlyMode,
      disableSelectionOnClick: true,
      disableCellSelection: true,
      selectionModel: psuSelectionModel,
      onRowSelectionModelChange: viewOnlyMode
        ? null // Disable row selection in view-only mode
        : (newSelection) => {
            setPsuSelectionModel(newSelection);
          },
      slots: {
        baseCheckbox: StyledCheckbox,
        noRowsOverlay: CustomGridRowsOverlay,
      },
    }),
    [psuMalFunctionData, columns]
  );

  const fanMalfunctionDataGridProps = React.useMemo(
    () => ({
      rows: Array.isArray(fanMalFunctionData)
        ? fanMalFunctionData
        : [],
      columns: [...columns],
      page: 0,
      loading:
        isAlertsDataLoading || isAlertsDataRefetching,
      getRowId: (row) => row.id,
      pagination: true,
      pageSize: fanMalFunctionData.length,
      disableColumnMenu: true,
      disableColumnResize: true,
      checkboxSelection: !viewOnlyMode,
      disableSelectionOnClick: true,
      disableCellSelection: true,
      selectionModel: fanSelectionModel,
      onRowSelectionModelChange: viewOnlyMode
        ? null // Disable row selection in view-only mode
        : (newSelection) => {
            setFanSelectionModel(newSelection);
          },
      slots: {
        baseCheckbox: StyledCheckbox,
        noRowsOverlay: CustomGridRowsOverlay,
      },
    }),
    [columns, fanMalFunctionData]
  );
    const leakDetectionDataGridProps = React.useMemo(
    () => ({
      rows: Array.isArray(leakDetectionData)
        ? leakDetectionData
        : [],
      columns: [...columns],
      page: 0,
      loading:
        isAlertsDataLoading || isAlertsDataRefetching,
      getRowId: (row) => row.id,
      pagination: true,
      pageSize: leakDetectionData.length,
      disableColumnMenu: true,
      disableColumnResize: true,
      checkboxSelection: !viewOnlyMode,
      disableSelectionOnClick: true,
      disableCellSelection: true,
      selectionModel: leakSelectionModel,
      onRowSelectionModelChange: viewOnlyMode
        ? null // Disable row selection in view-only mode
        : (newSelection) => {
            setLeakSelectionModel(newSelection);
          },
      slots: {
        baseCheckbox: StyledCheckbox,
        noRowsOverlay: CustomGridRowsOverlay,
      },
    }),
    [columns, leakDetectionData]
  );
  const chipMalfunctionDataGridProps = React.useMemo(
    () => ({
      rows: Array.isArray(chipMalFunctionData)
        ? chipMalFunctionData
        : [],
      columns: [...columns],
      page: 0,
      loading:
        isAlertsDataLoading || isAlertsDataRefetching,
      getRowId: (row) => row.id,
      pagination: true,
      pageSize: chipMalFunctionData.length,
      disableColumnMenu: true,
      disableColumnResize: true,
      checkboxSelection: !viewOnlyMode,
      disableSelectionOnClick: true,
      disableCellSelection: true,
      selectionModel: chipSelectionModel,
      onRowSelectionModelChange: viewOnlyMode
        ? null // Disable row selection in view-only mode
        : (newSelection) => {
            setChipSelectionModel(newSelection);
          },
      slots: {
        baseCheckbox: StyledCheckbox,
        noRowsOverlay: CustomGridRowsOverlay,
      },
    }),
    [chipMalFunctionData, columns]
  );

  return (
    <PageWrapper>
      <NotificationsPageHeader
        refetch={refetchAlertNotifications}
        setOpenNotificationConfigurationDialog={
          setOpenNotificationConfigurationDialog
        }
        viewOnlyMode={viewOnlyMode}
      />
      <Box
        className={"miner-page-table"}
        display={"flex"}
        flexDirection={"column"}
        backgroundColor={colors?.background?.paper}
        padding={"0.75rem 0.75rem 0rem 0.75rem"}
        borderRadius={"1rem"}
      >
        <Tabs
          value={selectedTab}
          onChange={(event, newValue) =>
            setSelectedTab(newValue)
          }
          variant="fullWidth"
          textColor="inherit"
          indicatorColor="primary"
          TabIndicatorProps={{
            children: <span className="MuiTabs-indicatorSpan" />
          }}
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              color: colors.text.label,
              fontFamily: "Roboto",
              fontSize: "1rem",
              fontWeight: "500",
              lineHeight: "1.25rem",
            },
            "& .Mui-selected": {
              color: colors.primary.main, // Use theme primary color for selected tab
            },
            "& .MuiTabs-indicator": {
              display: "flex",
              justifyContent: "center",
              height: "4px",
              backgroundColor: "transparent",
            },
            "& .MuiTabs-indicatorSpan": {
              backgroundColor: colors.primary.main,
              borderTopLeftRadius: 100,
              width: "25%",
              borderTopRightRadius: 100,
            },
          }}
        >
          <Tab label="Hashboard malfunction" />
          <Tab label="Fan malfunction" />
          <Tab label="PSU malfunction" />
          <Tab label="Chip malfunction" />
          <Tab label="Leak detection" />
        </Tabs>

        {selectedTab === 0 && (
          <HashBoardsMalfunctionTable
            datagridProps={hashboardMalfuncDataGridProps}
            selectionModel={hashboardSelectionModel}
            refetch={refetchAlertNotifications}
            tableKey={hashboardTableKey}
            setTableKey={setHashboardTableKey}
            alertNotificationData={alertNotificationData}
            viewOnlyMode={viewOnlyMode}
          />
        )}
        {selectedTab === 1 && (
          <FanMalfunctionTable
            datagridProps={fanMalfunctionDataGridProps}
            selectionModel={fanSelectionModel}
            refetch={refetchAlertNotifications}
            tableKey={fanTableKey}
            setTableKey={setFanTableKey}
            alertNotificationData={alertNotificationData}
            viewOnlyMode={viewOnlyMode}
          />
        )}
        {selectedTab === 2 && (
          <PSUMalfunctionTable
            datagridProps={psuMalfunctionDataGridProps}
            selectionModel={psuSelectionModel}
            refetch={refetchAlertNotifications}
            tableKey={psuTableKey}
            setTableKey={setPsuTableKey}
            alertNotificationData={alertNotificationData}
            viewOnlyMode={viewOnlyMode}
          />
        )}
        {selectedTab === 3 && (
          <ChipMalfunctionTable
            datagridProps={chipMalfunctionDataGridProps}
            selectionModel={chipSelectionModel}
            refetch={refetchAlertNotifications}
            tableKey={chipTableKey}
            setTableKey={setChipTableKey}
            alertNotificationData={alertNotificationData}
            viewOnlyMode={viewOnlyMode}
          />
        )}
        {selectedTab === 4 && (
          <LeakDetectionTable
            datagridProps={leakDetectionDataGridProps}
            selectionModel={leakSelectionModel}
            refetch={refetchAlertNotifications}
            tableKey={leakTableKey}
            setTableKey={setLeakTableKey}
            alertNotificationData={alertNotificationData}
            viewOnlyMode={viewOnlyMode}
          />
        )}
      </Box>
      <AddNotificationConfigurationDialog
        openNotificationConfigurationDialog={
          openNotificationConfigurationDialog
        }
        setOpenNotificationConfigurationDialog={
          setOpenNotificationConfigurationDialog
        }
        refetch={refetchAlertNotifications}
        authToken={authToken}
      />
    </PageWrapper>
  );
};

export default NotificationsPage;
